<template>
  <el-form
    :inline="true"
    :model="formModel"
    class="search-form"
    ref="form"
    :rules="mergeRules"
    size="small"
  >
    <el-form-item v-if="formModel.officeId !== undefined && formModel.taskId !== undefined">
      <el-radio-group v-model="officeOrTask">
        <el-radio-button label="office">{{ '机构' | translateTo }}</el-radio-button>
        <el-radio-button label="task">{{ '任务' | translateTo }}</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      :label="'机构:' | translateTo"
      v-if="
        formModel.officeId !== undefined &&
        officeOrTask === 'office' &&
        !hiddenItems.includes('officeId')
      "
      prop="officeId"
    >
      <el-tree-select v-model="formModel.officeId" :treeParams="officeTreeParams"></el-tree-select>
    </el-form-item>
    <el-form-item
      :label="'任务:' | translateTo"
      v-if="formModel.taskId !== undefined && officeOrTask === 'task'"
      prop="taskId"
    >
      <el-select
        v-model="formModel.taskId"
        collapse-tags
        clearable
        filterable
        :multiple="formModel.taskId | isArray"
      >
        <el-option v-for="v in tasks" :key="v.sn" :label="v.name" :value="v.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="'设备型号:' | translateTo"
      v-if="formModel.deviceModel !== undefined"
      prop="deviceModel"
    >
      <el-select
        v-model="formModel.deviceModel"
        collapse-tags
        clearable
        filterable
        :multiple="formModel.deviceModel | isArray"
      >
        <el-option
          v-for="(v, i) in deviceModels"
          :key="i"
          :label="v.label"
          :value="v.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="'设备:' | translateTo" v-if="formModel.sn !== undefined" prop="sn">
      <el-select
        v-model="formModel.sn"
        collapse-tags
        clearable
        filterable
        :multiple="formModel.sn | isArray"
        :no-data-text="'无设备' | translateTo"
      >
        <el-option v-for="v in deviceList" :key="v.sn" :label="v.name" :value="v.sn"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="'报警类型:' | translateTo"
      v-if="formModel.alarmType !== undefined"
      prop="alarmType"
    >
      <el-select
        v-model="formModel.alarmType"
        collapse-tags
        clearable
        filterable
        :multiple="formModel.alarmType | isArray"
        :no-data-text="'无报警类型' | translateTo"
      >
        <el-option
          v-for="v in alarmTypes"
          :key="v.value"
          :label="v.label"
          :value="v.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="'物质类型:' | translateTo"
      v-if="formModel.materialType !== undefined"
      prop="materialType"
    >
      <el-tree-select
        ref="treeSelect"
        v-model="formModel.materialType"
        :treeParams="materialTreeParams"
        :valueNoFather="true"
        @searchFun="searchFun"
      ></el-tree-select>
    </el-form-item>
    <el-form-item
      :label="'统计类型:' | translateTo"
      v-if="formModel.busiType !== undefined"
      prop="busiType"
    >
      <m-select v-model="formModel.busiType" :i18nPath="i18nPath" :optionArr="busiTypes"></m-select>
    </el-form-item>
    <el-form-item
      :label="'设备状态:' | translateTo"
      v-if="formModel.runstate !== undefined"
      prop="runstate"
    >
      <m-select
        v-model="formModel.runstate"
        :i18nPath="i18nPath"
        :translateLabel="true"
        :optionArr="deviceRunStates"
      ></m-select>
    </el-form-item>
    <el-form-item
      :label="'处置状态:' | translateTo"
      v-if="formModel.dispositionSituation !== undefined"
      prop="runstate"
    >
      <el-select v-model="formModel.dispositionSituation" collapse-tags clearable filterable>
        <el-option
          v-for="v in dispositionSituationOptions"
          :key="v.value"
          :label="v.label | translateTo"
          :value="v.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      :label="'报警内容:' | translateTo"
      v-if="formModel.message !== undefined"
      prop="message"
    >
      <el-input v-model="formModel.message"></el-input>
    </el-form-item>
    <el-form-item
      :label="'检测人:' | translateTo"
      v-if="formModel.tester !== undefined"
      prop="tester"
    >
      <el-input v-model="formModel.tester"></el-input>
    </el-form-item>

    <el-form-item
      :label="'核素名称:' | translateTo"
      v-if="formModel.nuclideName !== undefined"
      prop="nuclideName"
    >
      <el-input v-model="formModel.nuclideName"></el-input>
    </el-form-item>

    <el-form-item
      :label="'物质名:' | translateTo"
      v-if="formModel.materialName !== undefined"
      prop="materialName"
    >
      <el-input v-model="formModel.materialName"></el-input>
    </el-form-item>
    <el-form-item v-if="mulTime.mul">
      <el-radio-group v-model="mulTime.dateType">
        <el-radio-button label="dates">{{ '多选日期' | translateTo }}</el-radio-button>
        <el-radio-button label="daterange">{{ '期间日期' | translateTo }}</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <br v-if="newLine" />
    <el-form-item
      :label="'选择时间:' | translateTo"
      v-if="formModel.rangeDateVal !== undefined"
      prop="rangeDateVal"
    >
      <el-date-picker
        v-show="mulTime.dateType === 'dates'"
        :type="mulTime.type ? `${mulTime.type}s` : 'dates'"
        v-model="formModel.rangeDateVal"
        align="center"
        :default-value="defaultValue"
        value-format="timestamp"
        :placeholder="'选择一个或多个日期' | translateTo"
        @change="changeTime"
      ></el-date-picker>
      <el-date-picker
        v-show="mulTime.dateType === 'daterange'"
        v-model="formModel.rangeDateVal"
        align="center"
        :type="mulTime.type ? `${mulTime.type}range` : 'daterange'"
        :default-time="['00:00:00', '23:59:59']"
        value-format="timestamp"
        :range-separator="'至' | translateTo"
        :start-placeholder="'开始日期' | translateTo"
        :end-placeholder="'结束日期' | translateTo"
        @change="changeTime"
      ></el-date-picker>
      <el-date-picker
        v-show="mulTime.dateType === 'datetimerange'"
        align="center"
        v-model="formModel.rangeDateVal"
        type="datetimerange"
        value-format="timestamp"
        :range-separator="'至' | translateTo"
        :start-placeholder="'开始日期' | translateTo"
        :end-placeholder="'结束日期' | translateTo"
        @change="changeTime"
      ></el-date-picker>
      <el-time-picker
        v-show="mulTime.dateType === 'timePicker'"
        is-range
        align="center"
        v-model="formModel.rangeDateVal"
        :range-separator="'至' | translateTo"
        :start-placeholder="'开始时间' | translateTo"
        :end-placeholder="'结束时间' | translateTo"
        @change="changeTime"
      ></el-time-picker>
    </el-form-item>
    <el-form-item :label="'时间类型:' | translateTo" v-if="mulTime.switcher">
      <el-radio-group v-model="mulTime.type">
        <el-radio label="date">{{ '按天' | translateTo }}</el-radio>
        <el-radio label="month">{{ '按月' | translateTo }}</el-radio>
        <el-radio label="year">{{ '按年' | translateTo }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="formModel.linkType !== undefined">
      <el-radio-group v-model="formModel.linkType">
        <el-radio :label="0">{{ '非关联' | translateTo }}</el-radio>
        <el-radio :label="1">{{ '关联' | translateTo }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      class="data-interval"
      :label="'数据间隔：' | translateTo"
      v-if="formModel.dataInterval !== undefined"
    >
      <el-select v-model="formModel.dataInterval" placeholder="placeholder">
        <el-option v-for="i in 10" :key="`span-${i}`" :label="i" :value="i"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      class="data-interval-type"
      :label="'间隔类型：' | translateTo"
      prop="dataIntervalType"
      v-if="formModel.dataIntervalType !== undefined"
    >
      <el-select v-model="formModel.dataIntervalType" placeholder="">
        <el-option
          v-for="item in dataIntervalTypeOptions"
          :key="`data-span${item.value}`"
          :label="item.label | translateTo"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item
      :label="'导出类型' | translateTo"
      prop="exportType"
      v-if="formModel.exportType !== undefined"
    >
      <el-select v-model="formModel.exportType" collapse-tags>
        <el-option
          v-for="v in exportTypeArray"
          :key="v.id"
          :label="v.name | translateTo"
          :value="v.id"
          :disabled="v.disabled"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="'报表类型:' | translateTo" v-if="formModel.statType !== undefined">
      <el-radio-group v-model="formModel.statType">
        <el-radio v-for="v in statTypes" :key="v.label" :label="v.label" :disabled="v.disabled">
          {{ v.text }}
        </el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="ownLatestFlag">
      <el-checkbox v-model="formModel.latestFlag">{{ '最后十条' | translateTo }}</el-checkbox>
    </el-form-item>
    <el-form-item>
      <template v-for="(b, i) in formButton">
        <el-button
          :loading="b.loading"
          v-if="!b.code || authMenu[b.code]"
          type="primary"
          @click="validateEvent(b)"
          :key="i"
        >
          {{ b.text | translateTo }}
        </el-button>
      </template>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { isArray, merge } from 'lodash';

import { getDevicesList, getDeviceModels, getMaterialType, getAlarmType } from '@/api/baseInfo';
import { getOffice, getTask } from '@/api/auth';
import { arrify } from '@/utils/utils';
import { getTime } from '@/utils/date';

export default {
  components: {
    ElTreeSelect: () => import('@/components/elTreeSelect/index.vue'),
    MSelect: () => import('./m-select')
  },
  props: {
    upLeveName: {
      type: String
    },
    hiddenItems: {
      type: Array,
      default: () => []
    },
    dataTypeOptions: {
      type: Array,
      default: () => []
    },
    deviceNum: {
      type: String
    },
    mode: {
      type: String,
      default: 'office'
    },
    newLine: {
      type: Boolean,
      default: false
    },

    formModel: {
      type: Object,
      default() {
        return {};
      }
    },
    statBusiType: {
      type: Number,
      default: 1
    },
    deviceModelBusiType: Number,
    rules: {
      type: Object,
      default: () => {
        return {};
      }
    },
    mulTime: {
      type: Object,
      default: () => {
        return {
          mul: false,
          dateType: 'daterange'
        };
      }
    },
    formButton: {
      type: Array,
      default: () => {
        return [];
      }
    },
    filterDeviceFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      i18nPath: 'query',
      officeOrTask: this.mode,
      defaultValue: new Date(),
      deviceList: [],
      deviceModels: [],
      tasks: [],
      officeTreeParams: {
        data: [],
        checkStrictly: true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        }
      },
      materialTreeParams: {
        filterable: true,
        data: [],
        props: {
          value: 'id',
          label: 'zhName',
          children: 'matCategories'
        }
      },
      alarmTypes: [],
      statTypes: [
        { text: '日报', label: 1 },
        { text: '月报', label: 2 },
        { text: '年报', label: 3 }
      ],
      deviceRunStates: [
        { label: '离线', value: 0 },
        { label: '在线', value: 1 },
        { label: '故障', value: 3 }
      ],
      dispositionSituationOptions: [
        { label: '已处置', value: '1' },
        { label: '未处置', value: '0' }
      ],
      dataIntervalTypeOptions: [],
      exportTypeArray: [
        {
          id: '1',
          name: '日报警次数汇总',
          type: 'RG05',
          disabled: true
        },
        {
          id: '2',
          name: '日红外计数',
          type: 'RG05',
          disabled: true
        },
        {
          id: '3',
          name: '报警值高于本底倍数',
          type: 'RG05',
          disabled: true
        },
        {
          id: '4',
          name: ' 小时平均值'
        },
        {
          id: '5',
          name: '箱线图'
        }
      ]
    };
  },
  filters: {
    isArray(d) {
      return isArray(d);
    }
  },
  computed: {
    ...mapState('admin', ['busiTypes']),
    mergeRules() {
      const rules = merge(
        {
          // deviceModel: [
          //   {required: true, message: '请至少选择一项', trigger: 'change'}
          // ],
          busiType: [{ required: true, message: '请至少选择一项', trigger: 'change' }],
          rangeDateVal: [{ required: true, message: '请选择日期', trigger: 'change' }]
        },
        this.rules
      );

      Object.values(rules).forEach(arr => {
        arrify(arr).forEach(rule => {
          if (Reflect.has(rule, 'message')) {
            rule.message = this.translateTo(rule.message);
          }
        });
      });

      return rules;
    },
    dateType() {
      const t = this.formModel.dateTypeSwitcher;
      const dict = {
        day: 'yyyy-MM-dd',
        month: 'yyyy-MM',
        year: 'yyyy'
      };
      return t ? dict[t] : dict.day;
    },
    ownLatestFlag() {
      return typeof this.formModel.latestFlag === 'boolean';
    }
  },
  methods: {
    ...mapActions('admin', ['getStatType']),
    langChangeHandler() {
      this.init();
    },

    changeTime(val) {
      if (
        this.upLeveName === 'survey' ||
        this.upLeveName === 'monitor' ||
        this.upLeveName === 'safety' ||
        this.upLeveName === 'export'
      ) {
        let dateDiff = new Date(val[1]).getTime() - new Date(val[0]).getTime(); //时间差的毫秒数
        let dayDiff = Math.ceil(dateDiff / getTime('d')); //计算出相差天数
        if (dayDiff > 30) {
          this.$message.warning(this.translateTo('时间范围模板', 'query', { num: 30 }));
          this.formModel.rangeDateVal = [val[0], val[0] + getTime('d') * 30];
        }
      }
    },

    deviceChange() {
      let { officeId, deviceModel, taskId } = this.formModel;

      deviceModel = arrify(deviceModel || null);
      officeId = arrify(officeId || null);
      // this.formModel.sn = isArray(this.formModel.sn) ? [] : '';
      if (this.filterDeviceFlag) {
        deviceModel = this.filterDeviceModels;
      }

      const task = getDevicesList(
        this.officeOrTask === 'office'
          ? { officeId, deviceModel }
          : { taskId: Array.isArray(taskId) ? taskId : [taskId], deviceModel }
      );

      task.then(res => {
        res.data.forEach(item => {
          if (item.deviceType == 'GW1034M') item.name = 'α、β表面沾污仪 ';
        });
        this.deviceList = res.data;
      });

      return task;
    },
    alarmTypeChange() {
      this.formModel.alarmType = isArray(this.formModel.alarmType) ? [] : '';
      getAlarmType({
        busiType: this.deviceModelBusiType,
        deviceModel: arrify(this.formModel.deviceModel || null)
      }).then(res => {
        this.alarmTypes = res.data;
      });
    },
    materialTypeChange() {
      if (this.formModel.materialType) {
        this.formModel.materialType = isArray(this.formModel.materialType) ? [] : '';
      }
      if (this.formModel.materialType !== undefined) {
        const task = getMaterialType();
        task.then(res => {
          Object.assign(this.materialTreeParams, { data: res.data });
        });
        return task;
      }
    },
    validateEvent(b) {
      this.$refs['form'].validate(valid => {
        if (valid) {
          b.event(b);
        } else {
          return false;
        }
      });
    },
    searchFun(val) {
      this.$refs.treeSelect.$refs.tree.filter(val);
    },
    init() {
      const promiseList = [];
      this.filterDeviceModels = [];

      if (this.formModel.officeId !== undefined) {
        const task = getOffice({
          busiType: 2
        });
        promiseList.push(task);
        task.then(res => {
          Object.assign(this.officeTreeParams, { data: res.data });
        });
      }
      if (this.formModel.taskId !== undefined) {
        const task = getTask();
        promiseList.push(task);
        task.then(res => {
          this.tasks = res.data;
        });
      }
      if (this.formModel.deviceModel !== undefined) {
        const task = getDeviceModels({
          busiType: this.deviceModelBusiType
        });

        promiseList.push(task);

        task.then(res => {
          this.deviceModels = res.data;
        });
      }
      if (this.formModel.busiType !== undefined) {
        promiseList.push(
          this.getStatType({
            busiType: this.statBusiType,
            dataType: this.officeOrTask === 'office' ? 1 : 2
          })
        );
      }
      if (this.formModel.sn !== undefined && this.filterDeviceFlag === false) {
        promiseList.push(this.deviceChange());
      }
      if (this.formModel.alarmType !== undefined) {
        const task = getAlarmType({
          busiType: this.deviceModelBusiType,
          deviceModel: arrify(this.formModel.deviceModel || null)
        });

        promiseList.push(task);

        task.then(res => {
          this.alarmTypes = res.data;
        });
      }

      if (this.filterDeviceFlag) {
        const task = getDeviceModels({
          busiType: this.deviceModelBusiType
        });

        promiseList.push(
          task.then(res => {
            res.data.forEach(item => {
              this.filterDeviceModels.push(item.value);
            });
            // return this.deviceChange();
            promiseList.push(this.deviceChange());
          })
        );
      }

      promiseList.push(this.materialTypeChange());

      return Promise.all(promiseList);
    }
  },
  watch: {
    'formModel.taskId': {
      handler() {
        if (this.officeOrTask === 'task') this.deviceChange();
      },
      immediate: false
    },
    'formModel.officeId': {
      handler() {
        if (this.officeOrTask === 'office') this.deviceChange();
      },
      immediate: false
    },
    'formModel.deviceModel': {
      handler(newVal) {
        this.exportTypeArray.forEach(item => {
          if (item.type === 'RG05') {
            item.disabled = true;
          }
        });

        if (newVal === 'RG05') {
          this.exportTypeArray.forEach(item => {
            if (item.type === 'RG05') {
              item.disabled = false;
            }
          });
        } else {
          this.exportTypeArray.forEach(item => {
            if (item.type === 'RG05') {
              item.disabled = true;
            }
          });
        }

        if (this.formModel.sn !== undefined) this.deviceChange();
        if (this.formModel.alarmType !== undefined) this.alarmTypeChange();
      },
      immediate: false
    },

    officeOrTask: {
      handler() {
        if (this.formModel.officeId) {
          this.formModel.officeId = isArray(this.formModel.officeId) ? [] : '';
        }
        if (this.formModel.taskId) this.formModel.taskId = isArray(this.formModel.taskId) ? [] : '';
        if (this.formModel.sn) this.formModel.sn = isArray(this.formModel.sn) ? [] : '';
        if (this.formModel.busiType) {
          this.formModel.busiType = isArray(this.formModel.busiType) ? [] : '';
          this.getStatType({
            busiType: this.statBusiType,
            dataType: this.officeOrTask === 'office' ? 1 : 2
          });
        }
      },
      immediate: false
    },
    'mulTime.dateType'() {
      this.formModel.rangeDateVal = [];
    },
    dataTypeOptions: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.length) {
          this.dataIntervalTypeOptions = val;
        } else {
          this.dataIntervalTypeOptions = [
            { label: '秒', value: 's' },
            { label: '分', value: 'm' },
            { label: '时', value: 'h' }
          ];
        }
      }
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss">
.search-form {
  .all-choose {
    text-align: right;
    width: 100%;
    padding-right: 20px;
    box-sizing: border-box;
  }

  .data-interval,
  .data-interval-type {
    .el-select {
      width: 80px;
    }
  }
}
</style>
